import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import { VaultMobileList } from '../VaultMobileList/VaultMobileList';
import { useStore } from '../../../app/data/root.store';
import { useInView } from 'react-intersection-observer';
import { LoadingDots, MobilePageWrapper } from './VaultMobileView.styles';

export const VaultMobileView = observer(() => {
    const { vaultStore } = useStore();
    const { page, meta: { totalPages } } = vaultStore;
    const [isLoading, setIsLoading] = useState(false);

    const { ref, inView } = useInView({
        threshold: 0
    });

    const next = useCallback(async () => {
        setIsLoading(true);
        const el = document.getElementById('scrollableDiv');
        const currentScroll = el.scrollTop;
        await vaultStore.goToPage(page + 1);
        el.scrollTop = currentScroll;
        setIsLoading(false);
    }, [page, vaultStore]);

    useEffect(() => {
        if (!vaultStore.isLoading && inView && (page < totalPages)) {
            next();
        }

    }, [inView, next, page, totalPages, vaultStore.isLoading]);

    return (
        <MobilePageWrapper
            id="scrollableDiv"
            withHeader
        >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <VaultMobileList />
                {
                    ((page < totalPages)  || isLoading) &&
                    < div ref={ref}>
                        <LoadingDots />
                    </div>
                }
            </div>

        </MobilePageWrapper >
    );
});